import { NgModule } from '@angular/core';
import { ShowcaseComponent } from './component/showcase/showcase.component';
import { RouterModule, Routes } from '@angular/router';
import { MovieInfoComponent } from './component/movie-info/movie-info.component';
import { StreamComponent } from './component/stream/stream.component';
import { MovieComponent } from './component/movie-list/movie.component';
import { AuthGuard } from 'src/app/core/authentication/auth.guard';
import { NewMovieInfoComponent } from './component/new-movie-info/new-movie-info.component';
import { ShowcaseUiWrapperComponent } from './component/showcase-ui-wrapper/showcase-ui.component';
import { ShowcaseArchiveComponent } from './component/showcase-archive/showcase-archive.component';

const routes: Routes = [
  {
    path: '',
    component: ShowcaseComponent,
    children: [
      {
        path: 'movie',
        component: MovieComponent,
      },
      {
        path: 'features',
        component: MovieComponent,
      },
      {
        path: 'shorts',
        component: MovieComponent,
      },
      {
        path: 'emotion',
        component: MovieComponent,
      },
      {
        path: 'genre',
        component: MovieComponent,
      }
    ],
  },
  {
    path: 'archive',
    component: ShowcaseArchiveComponent,
    children: [
      {
        path: 'features',
        component: MovieComponent,
      },
      {
        path: 'shorts',
        component: MovieComponent,
      },
      {
        path: 'emotion',
        component: MovieComponent,
      },
      {
        path: 'genre',
        component: MovieComponent,
      }
    ],
  },
  {
    path: 'moviepage/:id/:movieName/:year',
    component: ShowcaseUiWrapperComponent,
  },
  {
    path: 'newmoviepage/:id/:movieName',
    component: NewMovieInfoComponent,
  },
  {
    path: 'movie/stream/:id/:movieName',
    component: StreamComponent,
    canActivate: [AuthGuard],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ShowcaseRoutingModule { }
